import { RootState } from "@platformx/authoring-state";
import { Loader, getCurrentLang, getSelectedSite, menuDisplayOrder } from "@platformx/utilities";
import { Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ProtectedRoute } from "../../router/ProtectedRoute";
import { convertToSnakeCase } from "../../utils/helper";
import Components from "./componentMapping";

interface DynamicRouteProps {
  generatedRoutes: any;
  generatedMenuItems: any;
}
interface RoutesProps {
  path: string;
  element: any;
}

export const useDynamicRoutes = (): DynamicRouteProps => {
  const { routes: unMappedRoutes = [] } = useSelector((state: RootState) => state?.routes);
  const [generatedRoutes, setGeneratedRoutes] = useState<any>();
  const [generatedMenuItems, setGeneratedMenuItems] = useState<any>([]);
  const iframedurl = `${window?.location?.origin}/${getSelectedSite()}/${getCurrentLang()}/content/common/preview`;

  const dynamicRoutesHandler = (routesList) => {
    const menus = {};
    const routes: RoutesProps[] = [];
    routesList?.forEach((item) => {
      const category = item?.category || "";
      if (item?.isMenu && !item?.isHidden) {
        if (!menus[category]) {
          menus[category] = {
            id: convertToSnakeCase(category),
            title: category,
            menu: [],
          };
        }
        menus[category]?.menu.push({ ...item, MenuName: item?.title });
      }

      const Component: any = Components?.[item?.component] || <div></div>;
      routes.push({
        path: item.url,
        element: (
          <>
            {item?.id === "access_denied" ? (
              <Component />
            ) : (
              <ProtectedRoute
                category={item?.category}
                subCategory={item?.subCategory}
                isHeader={item?.isHeader}
                isSideBar={item?.isSideBar}>
                <Suspense fallback={<Loader />}>
                  <Component
                    dashboardName={item?.component}
                    heading={item?.id}
                    type={item?.id}
                    iframeUrl={iframedurl}
                    isShared={item?.is_shared ?? true}
                  />
                </Suspense>
              </ProtectedRoute>
            )}
          </>
        ),
      });
    });
    const orderedMenu = menuDisplayOrder
      .map((item) => {
        return Object.values(menus)?.find(
          (menu: any) => menu.title.toLowerCase() === item.toLocaleLowerCase(),
        );
      })
      .filter(Boolean);
    return { dynamicMenu: orderedMenu, dynamicRoutes: routes };
  };

  useEffect(() => {
    if (unMappedRoutes) {
      const { dynamicMenu, dynamicRoutes } = dynamicRoutesHandler(unMappedRoutes);
      setGeneratedMenuItems(dynamicMenu);
      setGeneratedRoutes(dynamicRoutes);
    }
  }, [unMappedRoutes]);

  return { generatedRoutes, generatedMenuItems };
};
